import { Animation } from '../../../../interface';

export function leaveAnimationTop(AnimationC: Animation, baseEl: HTMLElement): Promise<Animation> {
  const baseAnimation = new AnimationC();

  const wrapperAnimation = new AnimationC();
  const wrapperEl = baseEl.querySelector('.lar-notify-wrapper');
  wrapperAnimation.addElement(wrapperEl);

  // Simple fade-out animation
  wrapperAnimation.fromTo('opacity', '1', '0');

  return Promise.resolve(baseAnimation
    .addElement(baseEl)
    .easing('ease-out')
    .duration(300)
    .add(wrapperAnimation));
}
